import React, { Fragment } from "react";
import styled from "styled-components";
import Lottie from "react-lottie";

import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import Container from "../components/container";
import Document from "../components/document";
import Footer from "../components/footer";
import Header from "../components/header";
import * as animationData from "../scanning.lottie.json";
import UploadFormContainer from "../components/upload-form/container";
import { useSelector } from "react-redux";
import {
  selectIsProcessing,
  selectIsUploading,
  selectImagesLoaded,
  selectError,
  selectExtractionsError
} from "../store/selector";
import theme from "../theme";

const ErrorText = styled.span`
  font-size: 16px;
  color: ${(props) => props.theme.palette.primary};
  font-family: "Muli", sans-serif;
  padding: 30px;
  text-align: center;
  max-width: 480px;
`;

const FileFormats = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.palette.primary};
  font-family: "Muli", sans-serif;
  margin-top: 10px;
`;

const ButtonBox = styled.div`
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LottieSizer = styled.div`
  width: 200px;
`;

const LottieContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const lottieOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData.default
};

const AnotherTryButton = () => (
  <ButtonBox>
    <UploadFormContainer buttonLabel="Upload another file" />
    <FileFormats>PNG, TIFF, PDF, JPG</FileFormats>
  </ButtonBox>
);

const ResultRoute = () => {
  const isProcessing = useSelector(selectIsProcessing);
  const isUploading = useSelector(selectIsUploading);
  const imagesLoaded = useSelector(selectImagesLoaded);
  const error = useSelector(selectError);
  const hasExtractionError = useSelector(selectExtractionsError);

  return (
    <Fragment>
      <Header />
      <Container>
        {!error && (isProcessing || isUploading || !imagesLoaded) && (
          <LottieContainer>
            <LottieSizer>
              <Lottie options={lottieOptions} />
            </LottieSizer>
          </LottieContainer>
        )}

        {error && (
          <>
            <div style={{ marginTop: "50px" }}>
              <ReportProblemIcon
                style={{ fontSize: 80, color: theme.palette.primary }}
              />
            </div>
            {!hasExtractionError && (
              <ErrorText>
                Sorry, there was an error during processing. Please try another
                document.
              </ErrorText>
            )}
            {hasExtractionError && (
              <ErrorText>
                Sorry, we do not think this is an invoice. Please try another
                document.
              </ErrorText>
            )}
            <AnotherTryButton />
          </>
        )}

        {!error && <Document />}

        {!isProcessing && !isUploading && imagesLoaded && <AnotherTryButton />}
      </Container>
      <Footer />
    </Fragment>
  );
};

export default ResultRoute;
